import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledImageContainer = styled(Box)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
}));

export const StyledImage = styled("img")(({ theme, cssProps }) => {
  const createResponsiveStyles = (styles) => {
    if (!styles || typeof styles !== "object") return {};

    let responsiveCSS = {};

    Object.entries(styles).forEach(([property, value]) => {
      if (typeof value === "object" && value !== null) {
        const breakpoints = ["xs", "sm", "md", "lg", "xl", "navMenu", "xxl"];

        breakpoints.forEach((breakpoint) => {
          if (value[breakpoint] !== undefined) {
            if (breakpoint === "xs") {
              responsiveCSS[property] = value[breakpoint];
            } else {
              const mediaQuery = theme.breakpoints.up(breakpoint);
              if (!responsiveCSS[mediaQuery]) {
                responsiveCSS[mediaQuery] = {};
              }
              responsiveCSS[mediaQuery][property] = value[breakpoint];
            }
          }
        });
      } else {
        // Regular non-responsive value
        responsiveCSS[property] = value;
      }
    });

    return responsiveCSS;
  };

  const processedCssProps = createResponsiveStyles(cssProps);

  return {
    borderRadius: "1rem",
    width: "100%",
    maxHeight: "285px",
    objectFit: "cover",
    [theme.breakpoints.up("sm")]: {
      // maxHeight: "300px",
    },
    [theme.breakpoints.up("md")]: {
      maxHeight: "350px",
    },
    ...processedCssProps,
  };
});
